import { render, staticRenderFns } from "./Gateways.vue?vue&type=template&id=70055ac0&scoped=true&"
import script from "./Gateways.vue?vue&type=script&lang=js&"
export * from "./Gateways.vue?vue&type=script&lang=js&"
import style0 from "./Gateways.vue?vue&type=style&index=0&id=70055ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70055ac0",
  null
  
)

export default component.exports